import { Context as NuxtContext } from '@nuxt/types';
import { Inject } from '@nuxt/types/app';
import axios from 'axios';

import { ApiClientMethod, createProxiedApi, getIntegrationConfig } from './_proxyUtils';
import { createAddIntegrationToCtx, createExtendIntegrationInCtx } from './context';

interface IntegrationContext {
  integration: {
    configure: (tag: string, configuration: any) => void;
    extend: (tag: string, integrationProperties: any) => void;
  }
}

type NuxtPluginWithIntegration = (ctx: NuxtContext & IntegrationContext, inject: Inject) => void | Promise<void>;

const parseCookies = (cookieString: string): Record<string, string> => Object.fromEntries(cookieString
  .split(';')
  .filter(String)
  .map((item) => item.split('=').map((part) => part.trim()))
  .map(([name, value]) => [name, value]));

const setCookieValues = (cookieValues: Record<string, string>, cookieString = '') => {
  const parsed = parseCookies(cookieString);

  // eslint-disable-next-line no-return-assign
  Object.entries(cookieValues).forEach(([name, value]) => parsed[name] = value);

  return Object.entries(parsed).map(([name, value]) => `${name}=${value}`).join('; ');
};

export const integrationPlugin = (pluginFn: NuxtPluginWithIntegration) => (nuxtCtx: NuxtContext, inject: Inject) => {
  const configure = (tag: string, configuration: { api: Record<string, ApiClientMethod> }) => {
    const injectInContext = createAddIntegrationToCtx({ tag, nuxtCtx, inject });
    // console.log('integrationPlugin configuration', configuration);
    const config = getIntegrationConfig(nuxtCtx, configuration);
    const { middlewareUrl, ssrMiddlewareUrl } = (nuxtCtx as any).$config;

    // console.log('integrationPlugin NODE_ENV', process.env.NODE_ENV);
    // console.log('integrationPlugin VSF_NUXT_APP_ENV', process.env.VSF_NUXT_APP_ENV);
    console.log('integrationPlugin process.server', process.server);
    console.log('integrationPlugin middlewareUrl', middlewareUrl);
    console.log('integrationPlugin ssrMiddlewareUrl', ssrMiddlewareUrl);
    if (middlewareUrl || ssrMiddlewareUrl) {
      config.axios.baseURL = process.server ? ssrMiddlewareUrl || middlewareUrl : middlewareUrl;
    }
    config.axios.timeout = 60000;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    const client = axios.create(config.axios);

    const api = createProxiedApi({
      givenApi: configuration.api || {}, client, tag, nuxtCtx,
    });

    if ((nuxtCtx.app.i18n as any).cookieValues) {
      // @ts-ignore
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      client.defaults.headers.cookie = setCookieValues((nuxtCtx.app.i18n as any).cookieValues, (client.defaults.headers as any).cookie);
    }
    injectInContext({ api, client, config });
  };

  const extend = (tag: string, integrationProperties: Record<string, unknown>) => {
    createExtendIntegrationInCtx({ tag, nuxtCtx, inject })(integrationProperties);
  };

  const integration = { configure, extend };

  pluginFn({ ...nuxtCtx, integration }, inject);
};
